<aside
  class="toast toast-stack"
  role="list">
  @for (toast of toastService.queue(); track toast.id) {
    <article
      class="toast toast--{{ toast.type }}"
      role="listitem"
      (mouseenter)="pauseToast(toast.id)"
      (mouseleave)="resumeToast(toast.id)">
      <div class="toast__section">
        @if (toast.icon) {
          <div class="toast__icon">
            <evc-icon
              [icon]="toast.icon"
              size="md"></evc-icon>
          </div>
        }
        <div class="toast__content">
          @if (toast.title) {
            <h1 class="toast__title">{{ toast.title }}</h1>
          }
          <p
            class="toast__description"
            [innerHTML]="toast.message"></p>
          @if (toast.action) {
            <evc-button
              class="toast__action"
              frame="full"
              size="small"
              [text]="toast.action.text"
              (click)="toast.action.callback()" />
          }
        </div>
      </div>
      <evc-button
        class="toast__close-icon toast__close-icon--{{ toast.type }}"
        frame="ghost"
        icon="close"
        size="small"
        (click)="toastService.remove(toast.id)"
        label="Close notification">
      </evc-button>
    </article>
  }
</aside>
